import { render, staticRenderFns } from "./SchoolCounselorHome.vue?vue&type=template&id=6950480d&"
import script from "./SchoolCounselorHome.vue?vue&type=script&lang=js&"
export * from "./SchoolCounselorHome.vue?vue&type=script&lang=js&"
import style0 from "./SchoolCounselorHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports